import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

// Custom hook to use the AuthContext
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        // Check if auth tokens exist in local storage
        return !!localStorage.getItem('token')
    });
    
    const [isLoading, setIsLoading] = useState(true);

    const login = () => {
        try {
            setIsAuthenticated(true);
            // Force a small delay to ensure state is properly set
            setTimeout(() => {
                setIsLoading(false);
            }, 50);
        } catch (error) {
            console.error('Error during login state update:', error);
            setIsLoading(false);
        }
    };

    const logout = () => {
        try {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            setIsAuthenticated(false);
            setIsLoading(false);
        } catch (error) {
            console.error('Error during logout:', error);
            setIsAuthenticated(false);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        // Optional: Log user out after a specific time or check tokens' validity
        const checkAuth = () => {
            try {
                const token = localStorage.getItem('token');
                const user = localStorage.getItem('user');

                // Here you can add any logic to verify tokens if needed
                // For now, it just checks if they exist
                const authenticated = !!(token && user);
                setIsAuthenticated(authenticated);
                setIsLoading(false);
            } catch (error) {
                console.error('Error checking authentication:', error);
                setIsAuthenticated(false);
                setIsLoading(false);
            }
        };

        checkAuth();
    }, []); // Runs once when the component mounts

    return (
        <AuthContext.Provider value={{ 
            isAuthenticated, 
            isLoading, 
            login, 
            logout 
        }}>
            {children}
        </AuthContext.Provider>
    );
};
